import React, { useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const IsTrustWorthyChart = ({ selectedProvince, selectedLocalMarket, data = [] }) => {

  const normalizeYearFormat = (data) => {
    return data.map(item => {
      if (typeof item.Year === "string" && item.Year.includes('-')) {
        item.Year = item.Year;
      }
      return item;
    });
  };

  const normalizedData = normalizeYearFormat(data);

  useLayoutEffect(() => {
    let chart = am4core.create('is-trustworthy', am4charts.XYChart);
    chart.logo.disabled = true;

    if (normalizedData && normalizedData.length > 0) {
      chart.data = normalizedData;

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'Year';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.line.disabled = true;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      const bankNames = ['Absa', 'Capitec', 'FNB', 'Nedbank', 'Standard Bank', 'TymeBank'];
      const colors = [am4core.color('#DF1641'), am4core.color('#FF3393'), am4core.color('#00CAFF'), am4core.color('#006E2C'), am4core.color('#0033A1'), am4core.color('#FFC000')];

      bankNames.forEach((bank, index) => {
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = bank;
        series.dataFields.categoryX = 'Year';
        series.name = bank;
        series.strokeWidth = 1.7;
        series.tensionX = 0.8;
        series.stroke = colors[index];
        series.tooltipText = '{name}: [bold]{valueY}[/]';

        series.tooltip.getFillFromObject = false; 
        series.tooltip.background.fill = colors[index]; 
        series.tooltip.label.fill = am4core.color('#FFFFFF');

        let boxBullet = series.bullets.push(new am4charts.Bullet());
        let roundedRectangle = boxBullet.createChild(am4core.RoundedRectangle);
        roundedRectangle.width = 35;
        roundedRectangle.height = 35;
        roundedRectangle.fill = colors[index];
        roundedRectangle.stroke = series.stroke;
        roundedRectangle.strokeWidth = 1;
        roundedRectangle.horizontalCenter = 'middle';
        roundedRectangle.verticalCenter = 'middle';
        roundedRectangle.cornerRadius(4, 5, 5, 4);

        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = '{valueY}';
        labelBullet.label.fill = am4core.color('#FFF');
        labelBullet.label.fontSize = 17;
        labelBullet.label.fontWeight = '500';
        labelBullet.label.horizontalCenter = 'middle';
        labelBullet.label.verticalCenter = 'middle';
        labelBullet.label.adapter.add('y', (y, target) => -roundedRectangle.height / 2 + 17);
      });

      chart.events.on("datavalidated", function() {
        chart.data.forEach((item) => {
          let label = chart.plotContainer.createChild(am4core.Label);
          label.text = `${item['Standard Bank Rank']}`;
          label.fontSize = 20;
          label.fontWeight = 'bold';
          label.fill = am4core.color('#0473EA');
          label.align = 'center';
          label.isMeasured = false;
          label.x = categoryAxis.categoryToPoint(item['Year']).x - label.measuredWidth / 2;
          label.y = -20;
        });
      });

      chart.legend = new am4charts.Legend();
      chart.legend.position = 'bottom';
      chart.legend.marginTop = 80;
      chart.legend.itemContainers.template.paddingRight = 5;
      chart.legend.itemContainers.template.paddingLeft = 20;
      chart.legend.labels.template.paddingLeft = 5;

      chart.cursor = new am4charts.XYCursor();
    }

    return () => {
      chart.dispose();
    };
  }, [normalizedData]);

  return <div id="is-trustworthy" style={{ width: "100%", height: "600px" }}></div>;
};

export default IsTrustWorthyChart;
